var lists_default = {
  "fontElementMap": "_0Qcq3",
  "orderedlist": "W3UpN",
  "bulletedlist": "ZH1H0",
  "listItem": "UhJqW"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
